import { create } from 'zustand'

type useDashboardState = {
	isEditMode: boolean;
  setEditMode: (isEdit: boolean) => void;
};

export const useDashboardStore = create<useDashboardState>()(set => ({
	isEditMode: false,
	setEditMode: isEdit => set(() => ({ isEditMode: isEdit })),
}));

export const setEditMode = (isEdit: boolean) => {
    useDashboardStore.setState({ isEditMode: isEdit })
}